// extracted by mini-css-extract-plugin
export default {"logo":"logo__aVn9GZ"};